import { useEffect, useRef, useMemo } from 'react';
import VirtualList, { TVirtualListRef } from '@creditflowresearch/uilib/VirtualList';
import cn from 'classnames';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';

import styles from './datePickerHeader.module.scss';

interface IYearItem {
  year: number,
}

interface IYearOverlayProps {
  selectedYear: number,
  minDate?: Date | null,
  maxDate?: Date | null,
  onSelect: (year: number) => void,
}

const ITEM_SIZE = 34;
const LIST_HEIGHT = 250;
const DEFAULT_MIN_YEAR = 1900;
const DEFAULT_MAX_YEAR = 2100;

const YearOverlay = ({ selectedYear, minDate, maxDate, onSelect }: IYearOverlayProps) => {
  const listRef = useRef<TVirtualListRef>(null);
  const minYear = minDate ? minDate.getFullYear() : DEFAULT_MIN_YEAR;
  const maxYear = maxDate ? maxDate.getFullYear() : DEFAULT_MAX_YEAR;

  const years: IYearItem[] = useMemo(() => {
    const items: IYearItem[] = [];
    for (let year = minYear; year <= maxYear; year++) {
      items.push({ year });
    }
    return items;
  }, [minYear, maxYear]);

  useEffect(() => {
    const index = selectedYear - minYear;
    if (listRef.current && index >= 0 && index < years.length) {
      listRef.current.scrollToRow({ index, align: 'center' });
    }
  }, [selectedYear, minYear, years.length]);

  return (
    <div className={ styles.overlay }>
      <VirtualList
        ref={ listRef }
        data={ years }
        itemKey="year"
        height={ LIST_HEIGHT }
        itemSize={ ITEM_SIZE }
        overscanCount={ 5 }
      >
        { ({ style, data }) => (
          <button
            type="button"
            style={ style }
            className={ cn(styles.overlayItem, { [styles.selected]: data.year === selectedYear }) }
            onClick={ () => onSelect(data.year) }
          >
            <span>{ data.year }</span>
            { data.year === selectedYear && <IconCheck className={ styles.checkmark } /> }
          </button>
        ) }
      </VirtualList>
    </div>
  );
};

export default YearOverlay;
